
const lenis = new Lenis({
  smoothWheel: true,
  smoothTouch: false,
  normalizeWheel: true,
  ignore: el => el.classList.contains("scroll-section")
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add(time => lenis.raf(time * 1000));
gsap.ticker.lagSmoothing(0);

const toggleButtons = document.querySelectorAll(".toggle-btn-d")
  , mainHeader = document.querySelector(".main-header");
toggleButtons.forEach(button => {
    button.addEventListener("click", () => {
        const targetClass = button.getAttribute("data-target")
          , targetMenu = document.querySelector(`.${targetClass}`);
        button.classList.toggle("active"),
        targetMenu.classList.toggle("active"),
        targetMenu.classList.contains("active") && mainHeader.classList.remove("to-transform"),
        (targetClass === "desk-menu-box" || targetClass === "mob-menu-box") && (targetMenu.classList.contains("active") ? lenis.stop() : lenis.start())
    }
    )
}
);
const deskMenuBox = document.querySelector(".desk-menu-box");
deskMenuBox && deskMenuBox.addEventListener("click", e => {
    if (e.target === deskMenuBox) {
        deskMenuBox.classList.remove("active");
        const button = document.querySelector('.toggle-btn-d[data-target="desk-menu-box"]');
        button && button.classList.remove("active"),
        mainHeader && mainHeader.classList.remove("to-transform"),
        lenis.start()
    }
}
);
const mobMenuBox = document.querySelector(".mob-menu-box");
mobMenuBox && mobMenuBox.addEventListener("click", e => {
    if (e.target === mobMenuBox) {
        mobMenuBox.classList.remove("active");
        const button = document.querySelector('.toggle-btn-d[data-target="mob-menu-box"]');
        button && button.classList.remove("active"),
        mainHeader && mainHeader.classList.remove("to-transform"),
        lenis.start()
    }
}
);

function initAllSwipers(scope = document) {
  if (typeof Swiper === "undefined") return;

  scope.querySelectorAll(".swiper-container:not(.swiper-initialized)").forEach((container) => {
    // Skip any swiper inside .cust-recom
    if (container.closest(".cust-recom")) return;

    new Swiper(container, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: container.querySelector(".swiper-pagination"),
        clickable: true
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initAllSwipers();

  // Watch for any native product-recommendations block that loads its cards later
  document.querySelectorAll("product-recommendations").forEach((block) => {
    const observer = new MutationObserver(() => initAllSwipers(block));
    observer.observe(block, { childList: true, subtree: true });
  });
});

document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", e => {
        const accordion = e.target.closest(".pdp-accordion-main");
        if (!accordion)
            return;
        const tab = e.target.closest(".accordion-title li");
        if (!tab)
            return;
        const tabs = accordion.querySelectorAll(".accordion-title li")
          , contents = accordion.querySelectorAll(".accordion-content")
          , target = tab.dataset.tab;
        tabs.forEach(t => t.classList.toggle("active", t === tab)),
        contents.forEach(c => c.classList.toggle("active", c.dataset.content === target))
    }
    )
}
)



document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".cust-collection-page2");
  if (!wrapper) return;

  const options = wrapper.querySelectorAll("#grid-options li[data-columns]");

  // Set default on load — change 4 to whatever your default col count is
  const defaultCols = 4;
  wrapper.classList.add(`cols-${defaultCols}`);
  options.forEach((o) => {
    if (parseInt(o.dataset.columns, 10) === defaultCols) o.classList.add("active");
  });

  options.forEach((option) => {
    option.addEventListener("click", () => {
      const cols = parseInt(option.dataset.columns, 10);

      options.forEach((o) => o.classList.remove("active"));
      option.classList.add("active");

      wrapper.classList.remove("cols-1","cols-2","cols-3","cols-4","cols-5","cols-6");
      wrapper.classList.add(`cols-${cols}`);
    });
  });
});